/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import useAxiosPrivate from "contexts/interceptors/axios";

export default function SelectBulkRecipients({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  disabled,
  sx = { width: "100%" },
}) {
  const axiosPrivate = useAxiosPrivate();
  const [bulkRecipients, setBulkRecipients] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    axiosPrivate
      .get(`/I-Abide/getAllRecipients`)
      .then((e) => {
        // console.log(e?.data?.data);

        setBulkRecipients(e.data?.data); // e.data contains the array of recipients
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  // Initialize the selected recipient based on the current value
  const [selectedBulkRecipient, setSelectedBulkRecipient] = useState(
    bulkRecipients?.find((recipient) => recipient.id === value) || null
  );

  useEffect(() => {
    console.log(bulkRecipients);

    if (value) {
      setSelectedBulkRecipient(
        bulkRecipients?.find((recipient) => recipient.id === value) || null
      );
    }
  }, [bulkRecipients, value]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);

    if (newValue) {
      onChange?.(name, newValue || "");
      setSelectedBulkRecipient(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedBulkRecipient(null);
  };

  return (
    <Box>
      <TextField
        label={error ? `${label} - ${error}` : label}
        placeholder={error ? `${placeholder} - ${error}` : placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={error || disabled}
        value={
          selectedBulkRecipient ? selectedBulkRecipient.recipient_name : ""
        }
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            <>
              {loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <>
                  {selectedBulkRecipient && (
                    <IconButton edge="end" onClick={handleClear}>
                      <CloseIcon />
                    </IconButton>
                  )}
                  {!disabled && !error && (
                    <IconButton edge="end" onClick={handleClick}>
                      <ArrowDropDownIcon />
                    </IconButton>
                  )}
                </>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {bulkRecipients.map((recipient) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={recipient.id}
            onClick={() => handleClose(recipient)}
          >
            {recipient.recipient_name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
